export default "__VITE_ASSET__10b11712__"